import { mainSiteUrl, externalLinkAttrs } from '@/mocks/categories';

const featuredItems = [
  {
    id: 'feat-1',
    name: 'Air Jordan 1 Low OG',
    price: '¥199',
    tag: "Editor's Pick",
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20sneaker%20photographed%20on%20a%20white%20concrete%20ledge%20against%20a%20warm%20sunset%20backdrop%2C%20golden%20hour%20side%20lighting%2C%20product%20photography%20with%20dramatic%20sky%2C%20orange%20and%20pink%20gradient%20sky%2C%20clean%20sneaker%20silhouette%2C%20editorial%20streetwear%20style&width=600&height=700&seq=feat-aj1-low-2026&orientation=portrait',
  },
  {
    id: 'feat-2',
    name: 'Essentials Hoodie FOG',
    price: '¥168',
    tag: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20oversized%20grey%20hoodie%20draped%20over%20an%20antique%20wooden%20chair%20in%20a%20sunlit%20room%20with%20long%20shadows%20stretching%20across%20a%20herringbone%20wooden%20floor%2C%20warm%20afternoon%20light%2C%20cozy%20interior%20photography%2C%20premium%20textile%20texture%2C%20cream%20and%20oak%20tones&width=600&height=700&seq=feat-essentials-hoodie-2026&orientation=portrait',
  },
  {
    id: 'feat-3',
    name: 'Gallery Dept Tee',
    price: '¥89',
    tag: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20white%20graphic%20t-shirt%20hanging%20on%20a%20minimalist%20clothes%20hanger%20against%20a%20rough%20exposed%20brick%20wall%2C%20single%20spotlight%20from%20above%2C%20grunge%20art%20gallery%20aesthetic%2C%20high%20contrast%20lighting%2C%20textural%20industrial%20backdrop%2C%20editorial%20fashion%20photography&width=600&height=700&seq=feat-gallery-tee-2026&orientation=portrait',
  },
  {
    id: 'feat-4',
    name: "Arc'teryx Beta Jacket",
    price: '¥380',
    tag: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20sleek%20black%20technical%20outdoor%20jacket%20laid%20flat%20on%20a%20dark%20slate%20rock%20surface%20in%20a%20misty%20forest%20setting%2C%20diffused%20natural%20light%20through%20fog%2C%20atmospheric%20outdoor%20product%20photography%2C%20moody%20green%20and%20grey%20tones%2C%20adventure%20gear%20aesthetic&width=600&height=700&seq=feat-arcteryx-jacket-2026&orientation=portrait',
  },
];

export default function FeaturedProducts() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Featured This Week
          </h2>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-6 px-6 md:-mx-10 md:px-10 scrollbar-hide">
          {featuredItems.map((item) => (
            <a
              key={item.id}
              href={mainSiteUrl}
              {...externalLinkAttrs}
              className="group flex-shrink-0 w-[260px] md:w-[300px] rounded-lg bg-background-100 border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative">
                {item.tag && (
                  <span className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-md bg-foreground-950 text-white text-[10px] font-semibold uppercase tracking-wider">
                    {item.tag}
                  </span>
                )}
                <div className="h-[220px] md:h-[260px] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 text-center">
                  {item.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 text-center">
                  {item.price}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}